import { Stack } from '@mui/material';
import { FC, ReactNode } from 'react';

interface Props {
  children: ReactNode;
}

export const Actions: FC<Props> = ({ children }) => {
  return (
    <Stack direction="row" width="100%" justifyContent="flex-end">
      {children}
    </Stack>
  );
};
